import * as $ from "jquery"

export default function AdminLayover() {
  let hideTimer = null

  $("body").on("mousemove", function (e) {
    if (e.pageX < 10) {
      $(".applet-admin-layover").show()
    }
  })

  $("body").on("keydown", function (e) {
    if (e.keyCode === 27) {
      $(".applet-admin-layover").hide()
    }
  })

  $("body").on("mouseenter", ".applet-admin-layover", function () {
    if (hideTimer !== null) {
      clearTimeout(hideTimer)
    }
  })

  $("body").on("mouseleave", ".applet-admin-layover", function () {
    hideTimer = setTimeout(function () {
      $(".applet-admin-layover").hide()
    }, 1000)
  })
}
